<script setup lang="ts">
// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    type?: "flex";
    direction?: "column" | "row";
  }>(),
  {
    type: "flex",
    direction: "column"
  }
);

const style: Record<string, string> = {};

function setStyle() {
  switch (props.type) {
    case "flex":
    default:
      style.display = "flex";
      style.flexDirection = props.direction;
      style.justifyContent = "center";
      style.alignItems = "center";
  }
}
setStyle();

defineExpose({});
</script>

<template>
  <div
    class="content-center"
    :style="style"
  >
    <slot></slot>
  </div>
</template>
